import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BidBaseInforControllerService } from 'src/app/sdk/services';
import { BID_FORM_CONTENT } from '../bid/constant/bid-form-content';
import { BID_TABLE_CONTENT_TABLE1 } from '../bid/constant/bid-table-content';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';
import { BidBaseInfo, BidItem, BidItemDetail, BidTotalItem, DataOfTabel1 } from '../bid/interface/make-bid.interface';
import { BidSaveData, MakeBidService } from '../make-bid/service/make-bid.service';
import { BidInfo } from './interface/budget-estimates';
import { DetailApplicationService } from '../../service/detail-application.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-make-budget-estimates',
  templateUrl: './make-budget-estimates.component.html',
  styleUrls: ['./make-budget-estimates.component.scss']
})
export class MakeBudgetEstimatesComponent implements OnInit {
  @Input() makeBudgetEstimatesStatus: boolean = false;
  @Input() isDownLoadBid: boolean = false;
  @Input() editBudgetEstimatesStatus: boolean = false;
  @Input() reviewResultIsReject: boolean = false;
  @Input() uploadQuotationStatus: boolean = false;
  @Input() formid: string;
  @Input() getProjectCategory: number;
  @Input() step: number;
  @Input() getAssignPhone: string;//厂务工程师电话
  @Input() electromechanical: boolean = false;
  @Input() civilEngineering: boolean = false;
  @Input() getFormBudgetCharge: object = {};
  @Output() getSubmitBudgetSaveData = new EventEmitter<BidInfo>();
  @Output() sendProjectCategory = new EventEmitter<number>();
  @Output() budgetCodeAndCreditDepartment = new EventEmitter<object>();


  title = "";
  produceText = "";
  produceBudgetStatus: boolean = false;//是否已点击生成概算,true则显示价格,false则不显示价格
  table2TotalPrice = {};
  profitTotalPrice = {};
  taxRatesTotalPrice = {};
  table1TotalPrice = {};

  radioValue: string;//专案分类
  isVisible: boolean = true;//是否展开标单详情页面
  userid: string;
  civilVendorCode: string;
  elecVendorCode: string;

  // 标单form-content
  formContent = BID_FORM_CONTENT;

  bidType = [];
  // bidSave
  bidSaveData: BidSaveData = {};
  // 标单信息
  bidInfo = {
    "civil": {},
    "elec": {}
  };
  bidBaseInfor: BidBaseInfo = {};
  bidMaterialList: BidTotalItem = {};
  bidItem: BidItem[] = [];
  bidItemDetail: BidItemDetail[] = [];

  submitBidSaveData = {};//保存成功的标单信息

  // table1数据
  table1Data = BID_TABLE_CONTENT_TABLE1;
  listOfTable1Data: DataOfTabel1[] = [];

  // table2数据
  table2TotalRow = {
    notInUnitPrice: "Total",
    notInTotalPrice: '-',
    remark: '',
  };
  table2DataModel = {};
  initBaseMaterialData: [];//初始化的BaseMaterial的数组
  allBaseMaterialData = {};//所有的BaseMaterial的数组

  // DB中base_material_list的数据
  filterData = {};//已选的selectvalue
  selectColumns = ["bigType", "middleType", "smallType", "projectName", "brandNative", "specType"];
  outputColumns = ["pn", ...this.selectColumns, "unit", "notInUnitPrice"];
  table2Columns = ["pn", ...this.selectColumns, "unit", "quantity", "notInUnitPrice", "notInTotalPrice", "remark"];
  baseMaterialData: BidItemDetail = {};

  constructor(
    private lb4ApiService: Lb4ApiService,
    private makeBidService: MakeBidService,
    private message: NzMessageService,
    private bidBaseInforControllerService: BidBaseInforControllerService,
    private detailApplicationService: DetailApplicationService,
    private translateService: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    this.produceText = this.translateService.instant('Budgets.CreateBidOrEstimates');
    this.title = this.translateService.instant('Budgets.Bid');
    await this.getOnInitTable2Data();//获取制定标单的table2数据
    await this.getHistorySaveData();//获取历史保存数据
    this.getOnInitTable1Data();//获取制定标单的table1数据
    this.producePrice();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.bidType = [];
    if (this.civilEngineering) {
      this.bidType.push({ "text": this.translateService.instant('DetailInfo.CIVIL'), "value": "civil" });
    }
    if (this.electromechanical) {
      this.bidType.push({ "text": this.translateService.instant('DetailInfo.ELECTRO'), "value": "elec" });
    }
    if (this.bidType.length > 0) {
      this.producePrice();
    }
    if (!this.editBudgetEstimatesStatus) {
      // 获取DB中的专案分类
      this.radioValue = this.getProjectCategory === null ? this.radioValue : String(this.getProjectCategory);
      this.produceBudgetStatus = this.getProjectCategory === 0 ? true : this.produceBudgetStatus;
    }
  }

  // 专案分类
  nzRadioChange(event: string) {
    this.radioValue = event;
    // 如果选择的是专案工程
    if (this.radioValue === '1') {
      this.title = this.translateService.instant('Budgets.Bid');
      this.produceBudgetStatus = false;
    }
    this.sendProjectCategory.emit(Number(this.radioValue));
  }

  // 获取初始化的下拉选项
  async selectValueChange(obj: Object, type: string) {
    //{ "data": value, "key": name, "value": event, "index1": index1, "index2": index2 }
    await this.makeBidService.selectValueChange(obj, this.formid, this.userid).then(res => {
      this.bidInfo[type]['listOfBaseMaterialData'] = res.listOfBaseMaterialData;
      this.bidInfo[type]['bidSaveData']['bidItem'] = res.bidSaveData.bidItem;
      this.bidInfo[type]['bidSaveData']['bidItemDetail'] = res.bidSaveData.bidItemDetail;
      this.producePrice();
      this.getSubmitBudgetSaveData.emit(this.bidInfo);
    });
  }

  // 初始化的时候先检查DB有没有已保存的数据,有则显示在标单中
  async getHistorySaveData() {
    // 查询厂商标单制定的签核状态
    let signDataArr = (await this.detailApplicationService.getSignStep5Arr(this.formid)).signDataArr;
    let signData = {
      "civil": signDataArr.filter(ele => ele['civilOrElectro'] === 0),
      "elec": signDataArr.filter(ele => ele['civilOrElectro'] === 1)
    }
    for (let i = 0; i < 2; i++) {
      let historyData = [];
      let bidType = i === 0 ? "civil" : "elec";//土建标单||机电标单
      let filter = { "where": { "formId": this.formid, "bidCivilOrElectro": i } };
      await this.bidBaseInforControllerService.findBidInformation({ "body": filter }).toPromise().then(res => {
        historyData = res[0];
        if (Object.keys(historyData).length === 3) {// 如果有历史数据
          this.bidInfo[bidType].bidSaveData = {
            'bidBaseInfor': historyData['bidBaseInfor'],
            'bidMaterialList': historyData['bidMaterialList'],
          };
          const bidSaveData = JSON.parse(JSON.stringify(this.bidInfo[bidType]['bidSaveData']));
          for (let obj of signData[bidType]) {
            if (obj['status'] === 1) {//如果最新的厂商标单制定status是被驳回或待制定
              this.bidInfo[bidType]['bidSaveData'] = bidSaveData;
            }
            else {
              delete this.bidInfo[bidType]['bidSaveData'];
            }
          }
          if (this.bidInfo[bidType].bidSaveData !== undefined) {
            let vendorCode = this.bidInfo[bidType].bidSaveData.bidMaterialList.vendorCode;
            this.bidInfo[bidType].bidSaveData.bidBaseInfor.formId = this.formid;
            this.bidInfo[bidType].bidSaveData.bidBaseInfor.vendorCode = vendorCode;
            if (!this.bidInfo[bidType].bidSaveData.bidBaseInfor.monthlyDay) {
              this.bidInfo[bidType].bidSaveData.bidBaseInfor.monthlyDay = '90';
            }
            if (!this.bidInfo[bidType].bidSaveData.bidBaseInfor.quoteInday) {
              this.bidInfo[bidType].bidSaveData.bidBaseInfor.quoteInday = '90';
            }

            this.bidInfo[bidType].bidSaveData.bidMaterialList.formId = this.formid;
            this.bidInfo[bidType].bidSaveData.bidMaterialList.vendorCode = vendorCode;

            // 遍历历史数据并组成页面呈现的数据listOfBaseMaterialData
            this.bidInfo[bidType].listOfBaseMaterialData = this.makeBidService.getListOfBaseMaterialData(historyData);
          }
        }
      });
    }
  }

  // 生成概算
  produceBudgetOrBid() {
    // '生成标单(概算)'
    if (this.produceText === this.translateService.instant('Budgets.CreateBidOrEstimates')) {
      this.produceText = this.translateService.instant('Budgets.ChangeToBid');//切换至标单
      this.title = this.translateService.instant('Budgets.BidOrEstimates');//"标单(概算)"
      this.produceBudgetStatus = true;
      this.producePrice();
    } else {
      this.produceText = this.translateService.instant('Budgets.CreateBidOrEstimates');// "生成标单(概算)"
      this.title = this.translateService.instant('Budgets.Bid');//"标单"
      this.produceBudgetStatus = false;
    }
  }
  // 计算价格
  producePrice() {
    Object.keys(this.bidInfo).forEach(type => {
      this.table2TotalPrice[type] = 0;
      if (!!this.bidInfo[type]['listOfBaseMaterialData']) {
        for (let each of this.bidInfo[type]['listOfBaseMaterialData']) {
          for (let eachItemDetail of each['itemDetail']) {
            let notInTotalPrice: number;
            if (eachItemDetail['notInTotalPrice'] === '') {
              notInTotalPrice = 0;
            }
            else {
              notInTotalPrice = parseFloat(eachItemDetail['notInTotalPrice']);
            }
            this.table2TotalPrice[type] += notInTotalPrice;
          }
        }
        this.table2TotalPrice[type] = parseFloat(this.table2TotalPrice[type].toFixed(2));
        // let profit = this.bidInfo[type]['bidSaveData']['bidMaterialList']['profit'].includes('0.') ? parseFloat(this.bidInfo[type]['bidSaveData']['bidMaterialList']['profit']) : (parseFloat(this.bidInfo[type]['bidSaveData']['bidMaterialList']['profit'].replace("%", "")) / 100);
        // let taxRates = this.bidInfo[type]['bidSaveData']['bidMaterialList']['taxRates'].includes('0.') ? parseFloat(this.bidInfo[type]['bidSaveData']['bidMaterialList']['taxRates']) : (parseFloat(this.bidInfo[type]['bidSaveData']['bidMaterialList']['taxRates'].replace("%", "")) / 100);
        let profit = this.bidInfo[type]['bidSaveData']['bidMaterialList']['profit'].replace('%', '') / 100;
        let taxRates = this.bidInfo[type]['bidSaveData']['bidMaterialList']['taxRates'].replace('%', '') / 100;
        this.profitTotalPrice[type] = parseFloat((this.table2TotalPrice[type] * profit).toFixed(2));
        this.taxRatesTotalPrice[type] = parseFloat(((this.table2TotalPrice[type] + this.profitTotalPrice[type]) * taxRates).toFixed(2));
        this.table1TotalPrice[type] = parseFloat((this.table2TotalPrice[type] + this.profitTotalPrice[type] + this.taxRatesTotalPrice[type]).toFixed(2));
      }
    });
  }

  // 保存概算或标单
  saveBudgetOrBid(type: string) {
    let listOfBaseMaterialData = this.bidInfo[type]['listOfBaseMaterialData'];
    let vendorCode = this.bidInfo[type]['bidSaveData']['bidMaterialList']['vendorCode']
    if (vendorCode !== undefined) {
      if (isNaN(this.bidInfo[type]['bidSaveData']['bidBaseInfor']['deliveryCycle'])) {//是否为非数字
        this.message.create('error', this.translateService.instant('CommonMessageTip.deliveryCycleTip'));
      }
      else {
        this.makeBidService.saveBid(this.formid, vendorCode, listOfBaseMaterialData, this.bidInfo[type]['bidSaveData']).then(res => {
          this.bidInfo[type]['submitBidSaveData'] = res.submitBidSaveData;
          this.bidInfo[type]['bidSaveData']['bidItem'] = res.bidSaveData.bidItem;
          this.bidInfo[type]['bidSaveData']['bidItemDetail'] = res.bidSaveData.bidItemDetail;
          this.getSubmitBudgetSaveData.emit(this.bidInfo);
        });
      }
    }
  }

  // 下载概算或标单
  downloadBudgetOrBid(type: string) {
    if (!!this.radioValue) {
      if (!!this.bidInfo[type]['listOfTable1Data']) {
        this.bidInfo[type]['listOfTable1Data'][0]['materialCostTotalPrice'] = this.table2TotalPrice[type] + "";
        this.bidInfo[type]['listOfTable1Data'][1]['profitTotalPrice'] = this.profitTotalPrice[type] + "";
        this.bidInfo[type]['listOfTable1Data'][2]['taxRatesTotalPrice'] = this.taxRatesTotalPrice[type] + "";
        this.bidInfo[type]['listOfTable1Data'][3]['table1TotalPrice'] = this.table1TotalPrice[type] + "";
      }
      this.makeBidService.downloadBid(this.bidInfo[type]['bidSaveData'], this.bidInfo[type]['listOfTable1Data'], this.bidInfo[type]['listOfBaseMaterialData'], this.step, Number(this.radioValue));
    } else {
      this.message.create('error', this.translateService.instant('CommonMessageTip.selectProjectCategoryTip'));
    }

  }
  // 子组件中form改变后触发
  formChanged(obj: Object, type: string) {
    this.bidInfo[type]['bidSaveData']['bidBaseInfor'][obj['key']] = obj['value'];
  }
  // 子组件中item改变触发
  itemChange(obj: Object, type: string) {
    let value = obj['event'];
    let index1 = obj['index1'];
    this.bidInfo[type]['listOfBaseMaterialData'][index1]['item'] = value;
  }
  // 子组件中table1备注改变触发
  table1RemarkChanged(e: object, type: string) {
    if (e['index'] === 0) {
      this.bidInfo[type]['listOfTable1Data'][e['index']]['remark'] = e['value'];
      this.bidInfo[type]['bidSaveData']['bidMaterialList']['materialCostRemark'] = e['value'];
    }
    else if (e['index'] === 1) {
      this.bidInfo[type]['listOfTable1Data'][e['index']]['remark'] = e['value'];
      this.bidInfo[type]['bidSaveData']['bidMaterialList']['profitRemark'] = e['value'];
    }
    else if (e['index'] === 2) {
      this.bidInfo[type]['listOfTable1Data'][e['index']]['remark'] = e['value'];
      this.bidInfo[type]['bidSaveData']['bidMaterialList']['taxRatesRemark'] = e['value'];
    }
    else {
      this.bidInfo[type]['listOfTable1Data'][e['index']]['remark'] = e['value'];
      this.bidInfo[type]['bidSaveData']['bidMaterialList']['remark'] = e['value'];
    }
  }

  // 子组件中table1的占比change
  table1ScaleChanged(e: object, type: string) {
    this.bidInfo[type]['listOfTable1Data'][e['index']]['scale'] = e['value'] + '%';
    this.bidInfo[type]['listOfTable1Data'][e['index']]['scaleNumber'] = e['value'];

    if (e['index'] === 1) {
      this.bidInfo[type]['bidSaveData']['bidMaterialList']['profit'] = e['value'] + '%';
      this.bidInfo[type]['listOfTable1Data'][e['index']]['profit'] = e['value'] + '%';
    }
    else {
      this.bidInfo[type]['bidSaveData']['bidMaterialList']['taxRates'] = e['value'] + '%';
      this.bidInfo[type]['listOfTable1Data'][e['index']]['taxRates'] = e['value'] + '%';
    }
    this.producePrice();
  }

  // 子组件中table底部的备注下拉信息改变触发
  remarkSelectChange(e: object, type: string) {
    this.bidInfo[type]['bidSaveData']['bidBaseInfor'][e['key']] = e['value'];
  }

  // 新增大项
  async addList(index1: number, type: string) {
    let listOfBaseMaterialData = [...this.bidInfo[type]['listOfBaseMaterialData']];
    listOfBaseMaterialData.splice(index1 + 1, 0, JSON.parse(JSON.stringify(this.table2DataModel)));
    this.bidInfo[type]['listOfBaseMaterialData'] = listOfBaseMaterialData;
  }

  // 删除大项
  async delList(index1: number, type: string) {
    let item = this.bidInfo[type]['listOfBaseMaterialData'][index1]['item'];
    let listOfBaseMaterialData = [...this.bidInfo[type]['listOfBaseMaterialData']];
    if (this.bidInfo[type]['listOfBaseMaterialData'].length > 1) {
      // 删除this.listOfBaseMaterialData中的此大项
      listOfBaseMaterialData.splice(index1, 1);
      this.bidInfo[type]['listOfBaseMaterialData'] = listOfBaseMaterialData;
      // 删除table:bid_item中的相关数据
      let idOfBidItem = await this.lb4ApiService.find('bid_item', {
        order: 'id DESC',
        fields: { id: true },
        where: { formId: this.formid, vendorCode: this.userid, item: item }
      });
      if (idOfBidItem.length > 0) {
        // 删除bid_item表中的数据
        this.lb4ApiService.deleteById('bid_item', idOfBidItem[0]['id']);
      }
    } else {
      this.message.create('warning', this.translateService.instant('CommonMessageTip.delBidListTip'));
    }
    this.producePrice();
  }

  // 添加行
  async addRow(obj: Object, type: string) {
    const index1 = obj['index1'];
    const index2 = obj['index2'];
    let listOfBaseMaterialData = [...this.bidInfo[type]['listOfBaseMaterialData']];
    listOfBaseMaterialData[index1]['itemDetail'].splice(index2 + 1, 0, JSON.parse(JSON.stringify(this.baseMaterialData)));
    this.bidInfo[type]['listOfBaseMaterialData'] = listOfBaseMaterialData;
  }

  // 删除行
  async delRow(obj: Object, type: string) {
    const index1 = obj['index1'];
    const index2 = obj['index2'];
    let listOfBaseMaterialData = [...this.bidInfo[type]['listOfBaseMaterialData']];
    if (listOfBaseMaterialData[index1]['itemDetail'].length > 1) {
      listOfBaseMaterialData[index1]['itemDetail'].splice(index2, 1);
      this.bidInfo[type]['listOfBaseMaterialData'] = listOfBaseMaterialData;
    }
    else {
      this.message.create('warning', this.translateService.instant('CommonMessageTip.delBidRowTip'));
    }
    this.producePrice();
  }

  // 初始化table数据
  async getOnInitTable1Data() {
    Object.keys(this.bidInfo).forEach(key => {
      if (Object.keys(this.bidInfo[key]).length > 0 && !!this.bidInfo[key]['bidSaveData']) {
        let bidMaterialList = this.bidInfo[key]['bidSaveData']['bidMaterialList'];
        this.makeBidService.getInitTable1Data(
          Number(bidMaterialList.profit.replace('%', '')), Number(bidMaterialList.taxRates.replace('%', '')),
          bidMaterialList['materialCostRemark'], bidMaterialList['profitRemark'],
          bidMaterialList['taxRatesRemark']
        ).then(res => {
          this.bidInfo[key]['listOfTable1Data'] = res.listOfTable1Data;
        });
      }
    });
  }

  async getOnInitTable2Data() {
    await this.makeBidService.getInitTable2Data().then(res => {
      this.table2DataModel = res.table2DataModel;
      this.baseMaterialData = res.baseMaterialData;
      this.allBaseMaterialData = res.allBaseMaterialData;
    });
  }
}
